import { render, staticRenderFns } from "./FnFormatUser.vue?vue&type=template&id=b626c4a4&"
import script from "./FnFormatUser.vue?vue&type=script&lang=js&"
export * from "./FnFormatUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports